import { useRef, useEffect } from "react";
import educadoLogo from "../images/educado_logo.png";

const ShareCard = ({ levelName, score, percentage }) => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Canvas size (OG standard)
    canvas.width = 1200;
    canvas.height = 630;

    // Background
    ctx.fillStyle = "#0F172A"; // dark blue
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    // Logo
    const logo = new Image();
    logo.src = educadoLogo;

    logo.onload = () => {
      ctx.drawImage(logo, 60, 50, 180, 60);

      // Title
      ctx.fillStyle = "#FFFFFF";
      ctx.font = "bold 60px Arial";
      ctx.fillText("Discover Your AI Level", 60, 220);

      // Level
      ctx.fillStyle = "#38BDF8";
      ctx.font = "bold 52px Arial";
      ctx.fillText(levelName, 60, 310);

      // Score
      ctx.fillStyle = "#E5E7EB";
      ctx.font = "36px Arial";
      ctx.fillText(`Score: ${score} (${percentage}%)`, 60, 380);

      // Footer
      ctx.font = "28px Arial";
      ctx.fillStyle = "#94A3B8";
      ctx.fillText("aiexam.educado.tech", 60, 460);
    };
  }, [levelName, score, percentage]);

  return <canvas ref={canvasRef} className="hidden" />;
};

export default ShareCard;
